import styled from "styled-components";
import { theme } from "@themes";

export const CardWrapper = styled.div`
  overflow: hidden;
  margin-left: 10px;
  width: fit-content;
  max-height: 50px;
  border-radius: 5px;
  font-family: ${({ theme }) => theme.font.primary}, arial, sans-serif;
  box-shadow: 3px 4px 3px 0px rgba(225, 225, 225, 0.5),
    0 0px 20px 0px rgba(225, 225, 225, 0.8);
  display: grid;
  grid-columns: ${({ activeicon }) => (!activeicon ? 3 : 2)};
  grid-template-columns: ${({ iconplusactive, activeicon }) =>
    iconplusactive && activeicon ? "50px 50px 1fr" : "50px 1fr"};
  cursor: pointer;
  @media only screen and (max-width: 480px) {
    width: 63vw;
  }
  h2 {
    text-align: left;
    font-size: 1.1em;
    margin: 0 0 20px 0;
    color: ${({ theme }) => theme.neutral.white};
    grid-column: 2;
  }
  p {
    text-align: left;
    grid-column: 2;
    font-size: 0.8em;
  }
  footer {
    font-size: 0.9em;
    text-align: left;
    grid-column: 2;
    color: ${({ theme }) => theme.primary.blue};
  }
  hr {
    border: 1px solid ${({ theme }) => theme.neutral.gray[300]};
    margin: 10px 12px;
  }
  &:hover {
    border-top: 1px solid
      ${(props) =>
        props.colorBorder
          ? props.colorBorder
          : theme.primary.blue} !important;
  }
`;
export const LeftWrapper = styled.div`
  grid-column: 1;
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.primary.purple};
`;
export const CenterWrapper = styled.div`
  grid-column: 2;
  background: ${({ theme }) => theme.primary.purple};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
`;
export const RightWrapper = styled.div`
  grid-column: ${({ iconplusactive }) => (iconplusactive ? 3 : 2)};
  background: ${({ theme }) => theme.primary.purple};
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 50px;
`;
export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    fill: ${(props) =>
      props.colorBorder ? props.colorBorder : theme.primary.purple};
    height: ${(props) => (props.loader ? "100%" : "50%")};
    width: ${(props) => (props.loader ? "100%" : "50%")};
  }
`;
